import { chain, zipObject } from 'lodash';

export const getGroupedData = (data, groupKey, propGroupedName) => {
  return chain(data)
    .groupBy(groupKey)
    .toPairs()
    .map((pair) => zipObject([groupKey, propGroupedName], pair))
    .value();
};
